<div
    class="card-indicator-performance card-indicator-performance--{{ type }}"
    fxLayout="column"
    [style]="{
        borderColor: getColorThemeByType()
    }"
>
    @if (isMobile()) {
        <div
            class="card-indicator-performance__header"
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="onClickInfo()"
        >
            @if (info) {
                <i class="fas fa-info-circle"></i>
            }
            <div class="card-indicator-performance__title text-12-semi-bold">
                {{ title }} {{ titleHint ? `(${titleHint})` : "" }}
            </div>
        </div>
    } @else {
        <div
            class="card-indicator-performance__header"
            fxLayout="row"
            fxLayoutAlign="start center"
            [matTooltip]="info"
        >
            @if (info) {
                <i class="fas fa-info-circle"></i>
            }
            <div fxLayout="column">
                <div
                    class="card-indicator-performance__title text-14-semi-bold"
                >
                    {{ title }}
                </div>
                @if (titleHint) {
                    <div
                        class="card-indicator-performance__title text-14-regular"
                    >
                        Fonte: {{ titleHint }}
                    </div>
                }
            </div>
        </div>
    }

    <div class="card-indicator-performance__content">
        <div
            class="values"
            fxLayout="row"
            fxLayoutAlign="start center"
            style="gap: var(--spacing-32)"
        >
            <div class="item" fxLayout="column">
                <span class="label">{{ month }}</span>
                <div fxLayout="row" fxLayout-align="start center">
                    <span
                        [class.month-percentage-value]="!monthPercentageValue"
                        [class.month-value]="monthPercentageValue"
                    >
                        {{ monthValue }}
                    </span>
                    @if (monthPercentageValue) {
                        <span class="month-percentage-value">
                            ({{ monthPercentageValue }})
                        </span>
                    }
                </div>
            </div>
            <div class="item" fxLayout="column">
                <span class="label">{{ referenceLabel }}</span>
                <span class="reference-value"
                    ><i
                        [class]="operators[operator]"
                        style="
                            font-size: var(--font-size-10);
                            position: relative;
                            top: -1px;
                            margin-right: var(--spacing-4);
                        "
                    ></i
                    >{{ referenceValue }}
                </span>
            </div>
        </div>
        <span fxFlex></span>
        <div class="status">
            <i
                class="icon-status {{ statusIcons[direction] }}"
                [class.icon-status--positive]="polarity == 'positive'"
                [class.icon-status--negative]="polarity == 'negative'"
                [class.icon-status--neutral]="polarity == 'neutral'"
                [style]="{
                    color: getColorThemeByStatus(direction)
                }"
            ></i>
            <!-- <span class="variation-percentage">{{ variationPercentage }}</span> -->
            <span class="text">{{ variation }}</span>
        </div>
        @if (progressOptions) {
            <dsn-progress-bar
                [value]="progressOptions.value"
                [color]="progressOptions.color"
                [customColor]="progressOptions.customColor"
                [divider]="progressOptions.mark"
                [marker]="true"
                [max]="progressOptions.range.max"
            ></dsn-progress-bar>
        }
    </div>
    @if (footerLabel) {
        <div
            class="card-indicator-performance__footer card-indicator-performance__footer--{{
                type
            }} {{
                isThemeCustom() && 'card-indicator-performance__footer--custom'
            }}"
        >
            {{ footerLabel }}
        </div>
    }
</div>
